/* STRYVE core — scroll reveals. Horizon scrolls .page-wrapper on desktop and the
   window on mobile; an IntersectionObserver with the default (viewport) root
   handles both, because intersection is computed through scroll containers. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;

  function pending() {
    return document.querySelectorAll('.sv-reveal:not(.is-in)');
  }

  function scan() {
    var els = pending();
    if (!io) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    els.forEach(function (el) { io.observe(el); });
  }

  if (!reduced && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', scan);

  window.Stryve = window.Stryve || {};
  window.Stryve.revealScan = scan;
})();
